module.exports = __webpack_public_path__ + "media/application/images/icons/down-arrow-transparent-9469b700cce3ba87378d9f83b55d6c67.svg";